// @ts-strict-ignore
import React from 'react'
import i18next from 'i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

interface FirstAndThirdPartyWithdrawalProps {
  amountWithdrawn: string
  fee?: number
  transactionReference: string
  currencyCode: string
}

const FirstAndThirdPartyWithdrawal = ({
  amountWithdrawn,
  fee,
  currencyCode,
  transactionReference,
}: FirstAndThirdPartyWithdrawalProps) => {
  const amountWithCurrency = `${amountWithdrawn} ${currencyCode}`
  const feeWithCurrency = fee ? `${fee} ${currencyCode}` : undefined
  return (
    <Box gapY={8}>
      <DataListItem
        id="amount-withdrawn"
        testId="amount-withdrawn"
        title={i18next.t('transactions.sideBar.amountWithdrawn')}
        body={amountWithCurrency}
      />
      {!!feeWithCurrency && (
        <DataListItem
          id="fee"
          testId="fee"
          title={i18next.t('transactions.sideBar.fee')}
          body={feeWithCurrency}
        />
      )}
      {!!transactionReference && (
        <DataListItem
          id="transaction-reference"
          testId="transaction-reference"
          title={i18next.t('transactions.sideBar.reference')}
          body={ellipseMiddleText(transactionReference, 20, 10)}
          copyText={transactionReference}
        />
      )}
    </Box>
  )
}

export default FirstAndThirdPartyWithdrawal
